import './Polyfill';
import { components } from './Apps/App';
import FontFaceObserver from 'fontfaceobserver';
import { backButton } from './Apps/BackLink';
//import '@pbeakk-premium-calculator/main';
import { revealElements } from './util';
import { init as initEventTracking } from './Apps/EventTracking';

const fonts = {
    regular: new FontFaceObserver('DINWeb'),
    bold: new FontFaceObserver('DINWeb', { weight: 'bold' }),
    boldCondensed: new FontFaceObserver('DINWeb', { stretch: 'condensed', weight: 'bold' }),
    light: new FontFaceObserver('DINWeb', { weight: '200' }),
    slab: new FontFaceObserver('Kievit Slab'),
    slabItalic: new FontFaceObserver('Kievit Slab', { style: 'italic' }),
    slabBold: new FontFaceObserver('Kievit Slab', { weight: 700 }),
    slabExtraBold: new FontFaceObserver('Kievit Slab', { weight: 900 }),
};
window.fontLoaders = fonts;
const loadFonts = cb => {
    const loadStart = Date.now();
    Promise.all([
        fonts.regular.load(),
        fonts.bold.load(),
    ]).then(() => {
        cb('dinweb-regular');
        cb('dinweb-bold');
        // loading of secondary fonts should not block loading of primary fonts
        // only append font classes aka swap fonts if they have loaded within .5s
        // (e.g. on second render)
        fonts.boldCondensed.load().then(() =>
            (Date.now() - loadStart < 500) && cb('dinweb-bold-condensed')
        );
        fonts.light.load().then(() =>
            (Date.now() - loadStart < 500) && cb('dinweb-light')
        );
    });
};

const giveClassToContainer = () => {
    const containerEl = document.querySelectorAll('.copy-container__content');
    for (let i = 0; i < containerEl.length; i++ ) {
        //console.log(containerEl[i].parentElement.className);
        if (containerEl[i].parentNode.classList.contains('accordion') ) {
            containerEl[i].className += ' js-accordion__content accordion__content';
            containerEl[i].previousSibling.classList.add('js-accordion__title');
        }
        else if (containerEl[i].parentNode.parentNode.classList.contains('tabs') ) {
            containerEl[i].className += ' js-tabs__content tabs__content';
            containerEl[i].previousSibling.classList.add('js-tabs__title');
        }
        else if (containerEl[i].parentNode.parentNode.classList.contains('accordiontabs') ) {
            containerEl[i].className += ' js-accordion__content js-tabs__content accordion__content tabs__content';
            containerEl[i].previousSibling.className += ' js-accordion__title js-tabs__title';
        }
    }
};

// add a class to all paragraph having an a.btn as childnode
const findParagraphWithButton = () => {
    const buttonLink = document.querySelectorAll('.copy-text .btn');
    for ( let i = 0; i < buttonLink.length; i++ ) {
        buttonLink[i].parentNode.classList.add('copy-text--with-button');
    }
};

// move keyboard focus to the first job link on the filter results page
const focusFirstFilterResult = () => {
    const firstJobLink = document.querySelector('.plugin-pbeakkjobs_filterresults .box.jobs-list a');
    if (firstJobLink) {
        firstJobLink.focus();
    }
};

// add a class to all paragraph having an a.btn as childnode
const checkTableWidth = () => {
    const allTable = document.querySelectorAll('.copy-text-table');
    const allTableContainer = document.querySelectorAll('.table-container');

    for ( let i = 0; i < allTable.length; i++ ) {
        if (allTable[i].offsetWidth > allTableContainer[i].offsetWidth) {
            allTableContainer[i].classList.add('table-container--is-smaller');
        }
        else {
            allTableContainer[i].classList.remove('table-container--is-smaller');
        }
    }
    window.onresize = function() {
        checkTableWidth();
    };
};

const initScrollReveal = () => {
    const anchorEl = document.location.hash ? document.querySelector(document.location.hash) : null;
    Array.from(document.querySelectorAll('.reveal,.reveal--big,.reveal--huge')).forEach(e => {
        if (e === anchorEl || e.contains(anchorEl)) {
            e.classList.remove('reveal');
            return;
        }
        e.style.opacity = 1.0;
    });
    Array.from(document.querySelectorAll('.site-main-content>.frame, .site-main-content>.section')).forEach((e, i) => {
        if (i === 0) {
            return;
        }
        if (anchorEl !== null && e.contains(anchorEl)) {
            return;
        }
        e.classList.add('reveal' + (h => {
            if (h > 5000) return '--huge';
            else if (h > 2500) return '--big';
            return '';
        })(e.offsetHeight));
        e.style.opacity = 1.0;
    });
    Array.from(document.querySelectorAll('.js-accordion-tabs.accordiontabs.frame')).forEach((e, i) => {
        if (i === 0) {
            e.classList.add('reveal' + (h => {
                if (h > 5000) return '--huge';
                else if (h > 2500) return '--big';
                return '';
            })(e.offsetHeight));
            e.style.opacity = 1.0;
        }
    });
    revealElements(document);
};

(function (callback){
    // in case the document is already rendered
    if (document.readyState !== 'loading') callback();
    // modern browsers
    else if (document.addEventListener) document.addEventListener('DOMContentLoaded', callback);
    // IE <= 8
    else document.attachEvent('onreadystatechange', function(){
        if (document.readyState === 'complete') callback();
    });
})(
    function() {
        loadFonts(c => document.documentElement.classList.add(c));
        initScrollReveal();
        components.serviceNavigation.init();
        giveClassToContainer();
        components.accordion.init();
        components.tabPanel.init();
        components.accordionTabs.init();
        components.searchModal.init();
        components.toggleButton.init();
        components.primaryNavigation.init();
        Array.from(document.querySelectorAll('.js-btn-back')).forEach(e => backButton(e));
        components.searchSuggestions.init();
        components.callbackService.init();
        findParagraphWithButton();
        checkTableWidth();
        focusFirstFilterResult();
        initEventTracking();
    }
);

